"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Observable_1 = require("rxjs/Observable");
var Subject_1 = require("rxjs/Subject");
var utils_1 = require("./utils");
// STOMP Client Class
//
// All STOMP protocol is exposed as methods of this class ('connect()',
// 'send()', etc.)
var WebSocketHandler = /** @class */ (function () {
    function WebSocketHandler(createWsConnection, options) {
        var _this = this;
        this.initConnection = function (headers) {
            return Observable_1.Observable.create(function (webSocketObserver) {
                if (_this.ws) {
                    throw 'Error, the connection has already been created !';
                }
                _this.ws = _this.createWS();
                if (!_this.ws) {
                    throw 'Error, createWsConnection function returned null !';
                }
                _this.ws.binaryType = 'arraybuffer';
                // Creating the Observables
                var messageReceived = new Subject_1.Subject();
                var messageReceipted = new Subject_1.Subject();
                var messageSender = new Subject_1.Subject();
                var inputSubscription;
                utils_1.logger.debug('Opening Web Socket...');
                _this.ws.onopen = function () {
                    utils_1.logger.debug('Web Socket Opened...');
                    inputSubscription = messageSender.subscribe(_this._send);
                    webSocketObserver.next({ messageReceived: messageReceived.asObservable(), messageSender: messageSender });
                };
                _this.ws.onmessage = function (evt) {
                    messageReceived.next(evt);
                };
                _this.ws.onclose = function (ev) {
                    utils_1.logger.debug("Whoops! Lost connection to " + _this.ws.url + ":", ev);
                    _this.ws = null;
                    webSocketObserver.error(ev);
                };
                return function () {
                    messageReceived.complete();
                    messageReceipted.complete();
                    inputSubscription && inputSubscription.unsubscribe();
                    _this.disconnect();
                };
            });
        };
        this.disconnect = function (headers) {
            if (headers === void 0) { headers = {}; }
            if (_this.ws) {
                _this.ws.onclose = null;
                _this.ws.close();
                _this.ws = null;
            }
        };
        // Base method to transmit any stomp frame
        this._send = function (data) {
            if (!_this.ws) {
                utils_1.logger.debug('Error, this.ws is null ! Possibly initConnection has not been called or not subscribed !');
                return;
            }
            utils_1.logger.debug(">>> " + data);
            _this._wsSend(_this.ws, data);
        };
        this._wsSend = function (ws, data) {
            if (_this.isBinary)
                data = utils_1.unicodeStringToTypedArray(data);
            utils_1.logger.debug(">>> length " + data.length);
            // if necessary, split the *STOMP* frame to send it on many smaller
            // *IWebSocket* frames
            while (true) {
                if (data.length > _this.maxWebSocketFrameSize) {
                    ws.send(data.slice(0, _this.maxWebSocketFrameSize));
                    data = data.slice(_this.maxWebSocketFrameSize);
                    utils_1.logger.debug("remaining = " + data.length);
                }
                else {
                    return ws.send(data);
                }
            }
        };
        // cannot have default options object + destructuring in the same time in method signature
        var _a = options.binary, binary = _a === void 0 ? false : _a;
        this.createWS = createWsConnection;
        this.isBinary = !!binary;
        // maximum *IWebSocket* frame size sent by the client. If the STOMP frame
        // is bigger than this value, the STOMP frame will be sent using multiple
        // IWebSocket frames (default is 16KiB)
        this.maxWebSocketFrameSize = 16 * 1024;
    }
    return WebSocketHandler;
}());
exports.default = WebSocketHandler;
